export default {
	template: require('/src/components/routerLinkExternal.html'),
	props: {
		to: String,
		host: String,
	},
}
